import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import { useCallback } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import PubSub from "../../../services/PubSub";
import NotificationTemplate from "../../../services/notificationTemplate";
import NotificationTemplateLayout from "./NotificationTemplateLayout";

const CreateNotificationTemplateModal = ({ show, onCancel }) => {
    const { id } = useParams();
    const [translate] = useTranslation();

    const create = useCallback(async (data) => {
        const payload = { ...data };
        delete payload.name;
        delete payload.toastType;
        delete payload.navigateTo;

        const response = await NotificationTemplate.createNotificationTemplate(
            id,
            {
                name: data.name,
                toastType: data.toastType,
                navigateTo: data.navigateTo,
                payload
            }
        );
        if (!response.error) {
            PubSub.publish('refresh-notifications', { newEntryId: response.data._id });
            onCancel();
        }
    }, [id, onCancel]);

    return (
        <BootstrapModal show={show} size='lg' backdrop="static">
            <Formik initialValues={{
                name: '',
                toastType: '',
                navigateTo: '',
                title: '',
                badge: '',
                body: '',
                icon: '',
                image: '',
                renotify: false,
                silent: false,
                requireInteraction: false
            }} validationSchema={Yup.object({
                name: Yup.string().min(2, translate("OTM_CHARACTERS_OR_MORE", { minCharacters: 2 })).required(" ")
            })} onSubmit={create}>
                <Form>
                    <BootstrapModal.Header className="h5 text-secondary">{translate("OTM_CREATE_NOTIFICATION_TEMPLATE")}</BootstrapModal.Header>
                    <BootstrapModal.Body>
                        <NotificationTemplateLayout />
                    </BootstrapModal.Body>
                    <BootstrapModal.Footer>
                        <Button type="submit" className="btn-sm">{translate("OTM_CREATE")}</Button>
                        <Button onClick={onCancel} variant="secondary" className="btn-sm">{translate("OTM_CANCEL")}</Button>
                    </BootstrapModal.Footer>
                </Form>
            </Formik>
        </BootstrapModal>
    );
};

export default CreateNotificationTemplateModal;
